import { createDecorator } from '../../instantiation/common/instantiation.js';
const IEnvironmentService = ( createDecorator('environmentService'));
export { IEnvironmentService };
